// This file is auto-generated by @hey-api/openapi-ts

import * as z from "zod";

export const zR2Messages = z.array(z.string());

export const zR2Errors = z.array(
	z.object({
		code: z.int().gte(1000),
		message: z.string(),
	})
);

export const zR2V4Response = z.object({
	errors: zR2Errors,
	messages: zR2Messages,
	result: z.record(z.string(), z.unknown()),
	success: z.literal(true),
});

/**
 * Name of the bucket.
 */
export const zR2BucketName = z
	.string()
	.min(3)
	.max(64)
	.regex(/^[a-z0-9][a-z0-9-]*[a-z0-9]/);

export const zR2V4ResponseFailure = z.object({
	errors: zR2Errors,
	messages: zR2Messages,
	result: z.unknown().nullable(),
	success: z.literal(false),
});

/**
 * A single R2 bucket.
 */
export const zR2Bucket = z.object({
	creation_date: z.string().optional(),
	name: zR2BucketName.optional(),
});

export const zR2ResultInfo = z.record(z.string(), z.unknown());

export const zR2V4ResponseList = zR2V4Response.and(
	z.object({
		result_info: zR2ResultInfo.optional(),
	})
);

/**
 * Opaque token indicating the position from which to continue when requesting the next set of records. A valid value for the cursor can be obtained from the cursors object in the result_info structure.
 */
export const zWorkersCursor = z.string();

export const zWorkersObject = z.object({
	hasStoredData: z.boolean().readonly().optional(),
	id: z.string().readonly().optional(),
	name: z.string().readonly().optional(),
});

/**
 * ID of the namespace.
 */
export const zWorkersSchemasId = z.string();

export const zWorkersMessages = z.array(
	z.object({
		code: z.int().gte(1000),
		documentation_url: z.string().optional(),
		message: z.string(),
		source: z
			.object({
				pointer: z.string().optional(),
			})
			.optional(),
	})
);

export const zWorkersApiResponseCommonFailure = z.object({
	errors: zWorkersMessages,
	messages: zWorkersMessages,
	result: z.unknown().nullable(),
	success: z.literal(false),
});

export const zWorkersNamespace = z.object({
	class: z.string().optional(),
	id: z.string().readonly().optional(),
	name: z.string().optional(),
	script: z.string().optional(),
	use_sqlite: z.boolean().optional(),
});

export const zWorkersApiResponseCommon = z.object({
	errors: zWorkersMessages,
	messages: zWorkersMessages,
	success: z.literal(true),
});

export const zWorkersApiResponseCollection = zWorkersApiResponseCommon.and(
	z.object({
		result_info: z
			.object({
				count: z.number().optional(),
				page: z.number().optional(),
				per_page: z.number().optional(),
				total_count: z.number().optional(),
				total_pages: z.number().optional(),
			})
			.optional(),
	})
);

export const zD1QueryMeta = z.object({
	changed_db: z.boolean().optional(),
	changes: z.number().optional(),
	duration: z.number().optional(),
	last_row_id: z.number().optional(),
	rows_read: z.number().optional(),
	rows_written: z.number().optional(),
	size_after: z.number().optional(),
	timings: z
		.object({
			sql_duration_ms: z.number().optional(),
		})
		.optional(),
});

export const zD1RawResultResponse = z.object({
	meta: zD1QueryMeta.optional(),
	results: z
		.object({
			columns: z.array(z.string()).optional(),
			rows: z
				.array(
					z.array(
						z.union([z.number(), z.string(), z.record(z.string(), z.unknown())])
					)
				)
				.optional(),
		})
		.optional(),
	success: z.boolean().optional(),
});

/**
 * Your SQL query. Supports multiple statements, joined by semicolons, which will be executed as a batch.
 */
export const zD1Sql = z.string();

export const zD1Params = z.array(z.string());

/**
 * single query
 *
 * A single query with or without parameters
 */
export const zD1SingleQuery = z.object({
	params: zD1Params.optional(),
	sql: zD1Sql,
});

/**
 * A single query object or a batch query object
 */
export const zD1BatchQuery = z.union([
	zD1SingleQuery,
	z.object({
		batch: z.array(zD1SingleQuery),
	}),
]);

/**
 * D1 database identifier (UUID).
 */
export const zD1DatabaseIdentifier = z.string().readonly();

export const zD1Messages = z.array(
	z.object({
		code: z.int().gte(1000),
		message: z.string(),
	})
);

export const zD1ApiResponseCommonFailure = z.object({
	errors: zD1Messages,
	messages: zD1Messages,
	result: z.unknown().nullable(),
	success: z.literal(false),
});

export const zD1DatabaseVersion = z.string().regex(/^(alpha|beta|production)$/);

/**
 * D1 database name.
 */
export const zD1DatabaseName = z.string().regex(/^[a-zA-Z0-9][a-zA-Z0-9_-]*$/);

/**
 * Specify the location to restrict the D1 database to run and store data. If this option is present, the location hint is ignored.
 */
export const zD1JurisdictionNullable = z.enum(["eu", "fedramp"]);

export const zD1DatabaseResponse = z.object({
	jurisdiction: zD1JurisdictionNullable.optional(),
	name: zD1DatabaseName.optional(),
	uuid: zD1DatabaseIdentifier.optional(),
	version: zD1DatabaseVersion.optional(),
});

export const zD1ApiResponseCommon = z.object({
	errors: zD1Messages,
	messages: zD1Messages,
	success: z.literal(true),
});

export const zWorkersKvAny = z
	.union([
		z.string(),
		z.number(),
		z.int(),
		z.boolean(),
		z.record(z.string(), z.unknown()),
		z.array(z.lazy((): any => zWorkersKvAny)),
	])
	.nullable();

/**
 * Expires the key at a certain time, measured in number of seconds since the UNIX epoch.
 */
export const zWorkersKvExpiration = z.number();

export const zWorkersKvBulkGetResultWithMetadata = z.object({
	values: z
		.record(
			z.string(),
			z
				.object({
					expiration: zWorkersKvExpiration.optional(),
					metadata: zWorkersKvAny.and(z.unknown()),
					value: zWorkersKvAny.and(z.unknown()),
				})
				.nullable()
		)
		.optional(),
});

export const zWorkersKvBulkGetResult = z.object({
	values: z
		.record(
			z.string(),
			z
				.union([
					z.string(),
					z.number(),
					z.boolean(),
					z.record(z.string(), z.unknown()),
				])
				.nullable()
		)
		.optional(),
});

/**
 * A key's name. The name may be at most 512 bytes. All printable, non-whitespace characters are valid.
 */
export const zWorkersKvKeyNameBulk = z.string().max(512);

export const zWorkersKvMessages = z.array(
	z.object({
		code: z.int().gte(1000),
		message: z.string(),
	})
);

export const zWorkersKvApiResponseCommon = z.object({
	errors: zWorkersKvMessages,
	messages: zWorkersKvMessages,
	success: z.literal(true),
});

export const zWorkersKvApiResponseCommonNoResult =
	zWorkersKvApiResponseCommon.and(
		z.object({
			result: z.record(z.string(), z.unknown()).nullish(),
		})
	);

export const zWorkersKvMetadata = zWorkersKvAny.and(z.unknown());

/**
 * A byte sequence to be stored, up to 25 MiB in length.
 */
export const zWorkersKvValue = z.union([z.string(), z.string()]);

/**
 * A key's name. The name may be at most 512 bytes. All printable, non-whitespace characters are valid. Use percent-encoding to define key names as part of a URL.
 */
export const zWorkersKvKeyName = z.string().max(512);

/**
 * Opaque token indicating the position from which to continue when requesting the next set of records if the amount of list results was limited by the limit parameter. A valid value for the cursor can be obtained from the cursors object in the result_info structure.
 */
export const zWorkersKvCursor = z.string();

export const zWorkersKvCursorResultInfo = z.object({
	count: z.number().optional(),
	cursor: zWorkersKvCursor.optional(),
});

export const zWorkersKvListMetadata = zWorkersKvAny.and(z.unknown());

/**
 * A name for a value. A value stored under a given key may be retrieved via the same key.
 */
export const zWorkersKvKey = z.object({
	expiration: z.number().optional(),
	metadata: zWorkersKvListMetadata.optional(),
	name: zWorkersKvKeyName,
});

/**
 * Namespace identifier tag.
 */
export const zWorkersKvNamespaceIdentifier = z.string().max(32).readonly();

export const zWorkersKvApiResponseCommonFailure = z.object({
	errors: zWorkersKvMessages,
	messages: zWorkersKvMessages,
	result: z.record(z.string(), z.unknown()).nullable(),
	success: z.literal(false),
});

/**
 * A human-readable string name for a Namespace.
 */
export const zWorkersKvNamespaceTitle = z.string().max(512);

export const zWorkersKvNamespace = z.object({
	id: zWorkersKvNamespaceIdentifier,
	title: zWorkersKvNamespaceTitle,
});

export const zWorkersKvResultInfo = z.object({
	count: z.number().optional(),
});

export const zWorkersKvApiResponseCollection = zWorkersKvApiResponseCommon.and(
	z.object({
		result_info: zWorkersKvResultInfo.optional(),
	})
);

export const zR2Object = z.object({
	key: z.string().optional(),
	etag: z.string().optional(),
	size: z.int().optional(),
	last_modified: z.iso.datetime().optional(),
	http_metadata: z.record(z.string(), z.string()).optional(),
	custom_metadata: z.record(z.string(), z.string()).optional(),
});

export const zR2ListObjectsResultInfo = z.object({
	delimited: z.array(z.string()).optional(),
	cursor: z.string().optional(),
	is_truncated: z.string().optional(),
});

export const zR2HeadObjectResult = z.object({
	key: z.string().optional(),
	etag: z.string().optional(),
	last_modified: z.string().optional(),
	size: z.int().optional(),
	http_metadata: z.record(z.string(), z.string()).optional(),
	custom_metadata: z.record(z.string(), z.string()).optional(),
});

export const zR2PutObjectResult = z.object({
	key: z.string().optional(),
	etag: z.string().optional(),
	size: z.int().optional(),
	version: z.string().optional(),
});

export const zDoSqlWithParams = z.object({
	sql: z.string().min(1),
	params: z.array(z.unknown()).optional(),
});

export const zDoQueryById = z.object({
	durable_object_id: z.string().min(1),
	queries: z.array(zDoSqlWithParams),
});

export const zDoQueryByName = z.object({
	durable_object_name: z.string().min(1),
	queries: z.array(zDoSqlWithParams),
});

export const zDoRawQueryResult = z.object({
	columns: z.array(z.string()).optional(),
	rows: z.array(z.array(z.unknown())).optional(),
	meta: z
		.object({
			rows_read: z.number().optional(),
			rows_written: z.number().optional(),
		})
		.optional(),
});

export const zLocalExplorerNamedBinding = z.object({
	bindingName: z.string(),
});

export const zLocalExplorerResourceBinding = z.object({
	id: z.string(),
	bindingName: z.string(),
});

export const zLocalExplorerDoBinding = z.object({
	id: z.string(),
	bindingName: z.string(),
	className: z.string(),
	scriptName: z.string(),
	useSqlite: z.boolean(),
});

export const zLocalExplorerWorkflowBinding = z.object({
	id: z.string(),
	bindingName: z.string(),
	className: z.string(),
	scriptName: z.string(),
});

/**
 * Resource bindings for a worker
 */
export const zLocalExplorerWorkerBindings = z.object({
	kv: z.array(zLocalExplorerResourceBinding).optional(),
	d1: z.array(zLocalExplorerResourceBinding).optional(),
	r2: z.array(zLocalExplorerResourceBinding).optional(),
	do: z.array(zLocalExplorerDoBinding).optional(),
	workflows: z.array(zLocalExplorerWorkflowBinding).optional(),
	sendEmail: z.array(zLocalExplorerNamedBinding).optional(),
});

export const zLocalExplorerWorker = z.object({
	isSelf: z.boolean(),
	name: z.string(),
	bindings: zLocalExplorerWorkerBindings.optional(),
});

/**
 * The name of the workflow.
 */
export const zWorkflowsWorkflowName = z.string();

/**
 * The unique identifier of a workflow instance.
 */
export const zWorkflowsInstanceId = z.string();

export const zWorkflowsWorkflow = z.object({
	name: z.string(),
	class_name: z.string().optional(),
	script_name: z.string().optional(),
});

export const zWorkflowsWorkflowDetails = z.object({
	name: z.string(),
	class_name: z.string(),
	script_name: z.string(),
	instances: z.object({
		complete: z.number().optional(),
		errored: z.number().optional(),
		paused: z.number().optional(),
		queued: z.number().optional(),
		running: z.number().optional(),
		terminated: z.number().optional(),
		waiting: z.number().optional(),
		waitingForPause: z.number().optional(),
	}),
});

export const zWorkflowsInstance = z.object({
	id: z.string(),
	status: z
		.enum([
			"queued",
			"running",
			"paused",
			"errored",
			"terminated",
			"complete",
			"waitingForPause",
			"waiting",
			"unknown",
		])
		.optional(),
	created_on: z.string().optional(),
});

export const zWorkflowsInstanceDetails = z.object({
	id: z.string(),
	status: z.enum([
		"queued",
		"running",
		"paused",
		"errored",
		"terminated",
		"complete",
		"waitingForPause",
		"waiting",
		"unknown",
	]),
	output: z.unknown().optional(),
	error: z
		.object({
			name: z.string().optional(),
			message: z.string().optional(),
		})
		.optional(),
});

/**
 * Columns and rows for a read-only SQL query.
 */
export const zObservabilityQueryResult = z.object({
	columns: z.array(z.string()),
	rows: z.array(z.array(z.unknown())),
});

/**
 * One entry in the ordered lifecycle of what the handler did to the message. `received` is first for any message actually delivered to an `email()` handler. The exception is `unhandled`: when the Worker exports no `email()` handler the message never reaches one, so the timeline is a single `unhandled` event with no preceding `received`. `forward`/`reply` events carry a `messageId` correlating with the matching `forwards`/`replies` entry.
 */
export const zEmailHandlerEvent = z.union([
	z.object({
		type: z.enum(["received", "reject", "unhandled"]),
		timestamp: z.string(),
	}),
	z.object({
		type: z.enum(["forward", "reply"]),
		timestamp: z.string(),
		messageId: z.string(),
	}),
]);

export const zEmailHandlerForward = z.object({
	messageId: z.string(),
	recipient: z.string(),
	headers: z.array(z.tuple([z.string(), z.string()])),
});

export const zEmailHandlerReply = z.object({
	messageId: z.string(),
	sender: z.string(),
	raw: z.string().optional(),
	rawBase64: z.string().optional(),
});

/**
 * Fields for composing a test email, mirroring MessageBuilder.
 */
export const zEmailSendRequest = z.object({
	from: z.string(),
	to: z.array(z.string()).min(1),
	cc: z.array(z.string()).optional(),
	bcc: z.array(z.string()).optional(),
	replyTo: z.string().optional(),
	subject: z.string(),
	text: z.string().optional(),
	html: z.string().optional(),
	headers: z.record(z.string(), z.string()).optional(),
	attachments: z
		.array(
			z.object({
				filename: z.string(),
				type: z.string(),
				content: z.string(),
				contentId: z.string().optional(),
				disposition: z.enum(["inline", "attachment"]).optional(),
			})
		)
		.optional(),
});

/**
 * Metadata describing an attachment on a captured email, without its content.
 */
export const zEmailAttachment = z.object({
	filename: z.string(),
	contentType: z.string(),
	disposition: z.enum(["inline", "attachment"]),
	size: z.number(),
});

export const zEmailBase = z.object({
	worker: z.string().optional(),
	from: z.string(),
	subject: z.string(),
	messageId: z.string(),
	attachments: z.array(zEmailAttachment),
});

export const zEmailRoutingItem = z.object({
	worker: z.string().optional(),
	from: z.string(),
	subject: z.string(),
	messageId: z.string(),
	attachments: z.array(zEmailAttachment),
	to: z.string(),
	cc: z.array(z.string()).optional(),
	headers: z.record(z.string(), z.string()).optional(),
	headerEntries: z.array(z.tuple([z.string(), z.string()])).optional(),
	receivedAt: z.string(),
	rawSize: z.number(),
	outcome: z.enum(["ok", "exception"]),
	rejectReason: z.string().optional(),
	forwards: z.array(zEmailHandlerForward),
	replies: z.array(zEmailHandlerReply),
	events: z.array(zEmailHandlerEvent),
});

export const zEmailRoutingDetail = z.object({
	worker: z.string().optional(),
	from: z.string(),
	subject: z.string(),
	messageId: z.string(),
	attachments: z.array(zEmailAttachment),
	to: z.string(),
	cc: z.array(z.string()).optional(),
	headers: z.record(z.string(), z.string()).optional(),
	headerEntries: z.array(z.tuple([z.string(), z.string()])).optional(),
	receivedAt: z.string(),
	rawSize: z.number(),
	outcome: z.enum(["ok", "exception"]),
	rejectReason: z.string().optional(),
	forwards: z.array(zEmailHandlerForward),
	replies: z.array(zEmailHandlerReply),
	events: z.array(zEmailHandlerEvent),
	text: z.string().optional(),
	html: z.string().optional(),
	raw: z.string(),
	rawBase64: z.string().optional(),
});

export const zEmailSendingItem = z.object({
	worker: z.string().optional(),
	from: z.string(),
	subject: z.string(),
	messageId: z.string(),
	attachments: z.array(zEmailAttachment),
	to: z.array(z.string()),
	cc: z.array(z.string()).optional(),
	bcc: z.array(z.string()).optional(),
	replyTo: z.string().optional(),
	sentAt: z.string(),
	headers: z.record(z.string(), z.string()).optional(),
});

export const zEmailSendingDetail = z.object({
	worker: z.string().optional(),
	from: z.string(),
	subject: z.string(),
	messageId: z.string(),
	attachments: z.array(zEmailAttachment),
	to: z.array(z.string()),
	cc: z.array(z.string()).optional(),
	bcc: z.array(z.string()).optional(),
	replyTo: z.string().optional(),
	sentAt: z.string(),
	headers: z.record(z.string(), z.string()).optional(),
	text: z.string().optional(),
	html: z.string().optional(),
	raw: z.string().optional(),
	rawBase64: z.string().optional(),
});

export const zR2ResultInfoWritable = z.record(z.string(), z.unknown());

export const zWorkersNamespaceWritable = z.object({
	class: z.string().optional(),
	name: z.string().optional(),
	script: z.string().optional(),
	use_sqlite: z.boolean().optional(),
});

export const zD1DatabaseResponseWritable = z.object({
	jurisdiction: zD1JurisdictionNullable.optional(),
	name: zD1DatabaseName.optional(),
	version: zD1DatabaseVersion.optional(),
});

export const zWorkersKvAnyWritable = z
	.union([
		z.string(),
		z.number(),
		z.int(),
		z.boolean(),
		z.record(z.string(), z.unknown()),
		z.array(z.lazy((): any => zWorkersKvAnyWritable)),
	])
	.nullable();

export const zWorkersKvMetadataWritable = zWorkersKvAnyWritable.and(
	z.unknown()
);

export const zWorkersKvListMetadataWritable = zWorkersKvAnyWritable.and(
	z.unknown()
);

export const zWorkersKvNamespaceWritable = z.object({
	title: zWorkersKvNamespaceTitle,
});

export const zWorkersKvNamespaceListNamespacesData = z.object({
	body: z.never().optional(),
	path: z.never().optional(),
	query: z
		.object({
			order: z.enum(["id", "title"]).optional(),
			direction: z.enum(["asc", "desc"]).optional(),
		})
		.optional(),
});

/**
 * List Namespaces response.
 */
export const zWorkersKvNamespaceListNamespacesResponse =
	zWorkersKvApiResponseCollection.and(
		z.object({
			result: z.array(zWorkersKvNamespace).optional(),
		})
	);

export const zWorkersKvNamespaceListANamespaceSKeysData = z.object({
	body: z.never().optional(),
	path: z.object({
		namespace_id: zWorkersKvNamespaceIdentifier,
	}),
	query: z
		.object({
			limit: z.number().gte(10).lte(1000).optional().default(1000),
			prefix: z.string().optional(),
			cursor: z.string().optional(),
		})
		.optional(),
});

/**
 * List a Namespace's Keys response.
 */
export const zWorkersKvNamespaceListANamespaceSKeysResponse =
	zWorkersKvApiResponseCommon.and(
		z.object({
			result: z.array(zWorkersKvKey).optional(),
			result_info: zWorkersKvCursorResultInfo.optional(),
		})
	);

export const zWorkersKvNamespaceDeleteKeyValuePairData = z.object({
	body: z.unknown(),
	path: z.object({
		key_name: zWorkersKvKeyName,
		namespace_id: zWorkersKvNamespaceIdentifier,
	}),
	query: z.never().optional(),
});

/**
 * Delete key-value pair response.
 */
export const zWorkersKvNamespaceDeleteKeyValuePairResponse =
	zWorkersKvApiResponseCommonNoResult;

export const zWorkersKvNamespaceReadKeyValuePairData = z.object({
	body: z.never().optional(),
	path: z.object({
		key_name: zWorkersKvKeyName,
		namespace_id: zWorkersKvNamespaceIdentifier,
	}),
	query: z.never().optional(),
});

/**
 * Read key-value pair response.
 */
export const zWorkersKvNamespaceReadKeyValuePairResponse = zWorkersKvValue;

export const zWorkersKvNamespaceWriteKeyValuePairWithMetadataData = z.object({
	body: zWorkersKvValue,
	path: z.object({
		key_name: zWorkersKvKeyName,
		namespace_id: zWorkersKvNamespaceIdentifier,
	}),
	query: z.never().optional(),
});

/**
 * Write key-value pair with metadata response.
 */
export const zWorkersKvNamespaceWriteKeyValuePairWithMetadataResponse =
	zWorkersKvApiResponseCommonNoResult;

export const zWorkersKvNamespaceGetMultipleKeyValuePairsData = z.object({
	body: z.object({
		keys: z.array(zWorkersKvKeyNameBulk).max(100),
	}),
	path: z.object({
		namespace_id: zWorkersKvNamespaceIdentifier,
	}),
	query: z.never().optional(),
});

/**
 * Get multiple key-value pairs response.
 */
export const zWorkersKvNamespaceGetMultipleKeyValuePairsResponse =
	zWorkersKvApiResponseCommonNoResult.and(
		z.object({
			result: z
				.union([zWorkersKvBulkGetResult, zWorkersKvBulkGetResultWithMetadata])
				.optional(),
		})
	);

export const zD1ListDatabasesData = z.object({
	body: z.never().optional(),
	path: z.never().optional(),
	query: z
		.object({
			name: z.string().optional(),
		})
		.optional(),
});

/**
 * List D1 databases response
 */
export const zD1ListDatabasesResponse = zD1ApiResponseCommon.and(
	z.object({
		result: z.array(zD1DatabaseResponse).optional(),
		result_info: z
			.object({
				count: z.number().optional(),
			})
			.optional(),
	})
);

export const zD1RawDatabaseQueryData = z.object({
	body: zD1BatchQuery,
	path: z.object({
		database_id: zD1DatabaseIdentifier,
	}),
	query: z.never().optional(),
});

/**
 * Raw query response
 */
export const zD1RawDatabaseQueryResponse = zD1ApiResponseCommon.and(
	z.object({
		result: z.array(zD1RawResultResponse).optional(),
	})
);

export const zDurableObjectsNamespaceListNamespacesData = z.object({
	body: z.never().optional(),
	path: z.never().optional(),
	query: z.never().optional(),
});

/**
 * List Namespaces response.
 */
export const zDurableObjectsNamespaceListNamespacesResponse =
	zWorkersApiResponseCollection.and(
		z.object({
			result: z.array(zWorkersNamespace).optional(),
		})
	);

export const zDurableObjectsNamespaceListObjectsData = z.object({
	body: z.never().optional(),
	path: z.object({
		id: zWorkersSchemasId,
	}),
	query: z
		.object({
			limit: z.number().gte(10).lte(10000).optional().default(1000),
			cursor: z.string().optional(),
		})
		.optional(),
});

/**
 * List Objects response.
 */
export const zDurableObjectsNamespaceListObjectsResponse =
	zWorkersApiResponseCollection.and(
		z.object({
			result: z.array(zWorkersObject).optional(),
			result_info: z
				.object({
					count: z.number().optional(),
					cursor: zWorkersCursor.optional(),
				})
				.optional(),
		})
	);

export const zR2ListBucketsData = z.object({
	body: z.never().optional(),
	path: z.never().optional(),
	query: z.never().optional(),
});

/**
 * List Buckets response.
 */
export const zR2ListBucketsResponse = zR2V4ResponseList.and(
	z.object({
		result: z
			.object({
				buckets: z.array(zR2Bucket).optional(),
			})
			.optional(),
	})
);

export const zR2GetBucketData = z.object({
	body: z.never().optional(),
	path: z.object({
		bucket_name: zR2BucketName,
	}),
	query: z.never().optional(),
});

/**
 * Get Bucket response.
 */
export const zR2GetBucketResponse = zR2V4Response.and(
	z.object({
		result: zR2Bucket.optional(),
	})
);

export const zR2BucketDeleteObjectsData = z.object({
	body: z.array(z.string()),
	path: z.object({
		bucket_name: z.string(),
	}),
	query: z.never().optional(),
});

/**
 * Delete objects response.
 */
export const zR2BucketDeleteObjectsResponse = zWorkersApiResponseCommon.and(
	z.object({
		result: z
			.array(
				z.object({
					key: z.string().optional(),
				})
			)
			.optional(),
	})
);

export const zR2BucketListObjectsData = z.object({
	body: z.never().optional(),
	path: z.object({
		bucket_name: z.string(),
	}),
	query: z
		.object({
			prefix: z.string().optional(),
			delimiter: z.string().optional(),
			cursor: z.string().optional(),
			per_page: z.int().optional().default(1000),
		})
		.optional(),
});

/**
 * List objects response.
 */
export const zR2BucketListObjectsResponse = zWorkersApiResponseCommon.and(
	z.object({
		result: z.array(zR2Object).optional(),
		result_info: zR2ListObjectsResultInfo.optional(),
	})
);

export const zR2BucketGetObjectData = z.object({
	body: z.never().optional(),
	path: z.object({
		bucket_name: z.string(),
		object_key: z.string(),
	}),
	query: z.never().optional(),
	headers: z
		.object({
			"cf-metadata-only": z.string().optional(),
		})
		.optional(),
});

/**
 * Object content or metadata.
 */
export const zR2BucketGetObjectResponse = zWorkersApiResponseCommon.and(
	z.object({
		result: zR2HeadObjectResult.optional(),
	})
);

export const zR2BucketPutObjectData = z.object({
	body: z.string(),
	path: z.object({
		bucket_name: z.string(),
		object_key: z.string(),
	}),
	query: z.never().optional(),
	headers: z
		.object({
			"content-type": z.string().optional(),
			"cf-r2-custom-metadata": z.string().optional(),
		})
		.optional(),
});

/**
 * Put object response.
 */
export const zR2BucketPutObjectResponse = zWorkersApiResponseCommon.and(
	z.object({
		result: zR2PutObjectResult.optional(),
	})
);

export const zDurableObjectsNamespaceQuerySqliteData = z.object({
	body: z.union([zDoQueryById, zDoQueryByName]),
	path: z.object({
		namespace_id: zWorkersSchemasId,
	}),
	query: z.never().optional(),
});

/**
 * Query response.
 */
export const zDurableObjectsNamespaceQuerySqliteResponse =
	zWorkersApiResponseCommon.and(
		z.object({
			result: z.array(zDoRawQueryResult).optional(),
		})
	);

export const zLocalExplorerListWorkersData = z.object({
	body: z.never().optional(),
	path: z.never().optional(),
	query: z.never().optional(),
});

/**
 * List workers response.
 */
export const zLocalExplorerListWorkersResponse = zWorkersApiResponseCommon.and(
	z.object({
		result: z.array(zLocalExplorerWorker).optional(),
	})
);

export const zEmailListRoutingData = z.object({
	body: z.never().optional(),
	path: z.never().optional(),
	query: z
		.object({
			worker: z.string().optional(),
			email_id: z.string().optional(),
			cursor: z.string().optional(),
			per_page: z.int().gte(1).lte(100).optional().default(25),
		})
		.optional(),
});

/**
 * List received emails response.
 */
export const zEmailListRoutingResponse = zWorkersApiResponseCommon.and(
	z.object({
		result: z
			.union([z.array(zEmailRoutingItem), zEmailRoutingDetail])
			.optional(),
		result_info: z
			.object({
				count: z.number().optional(),
				cursor: z.string().optional(),
				per_page: z.int().optional(),
				has_more: z.boolean().optional(),
			})
			.optional(),
	})
);

export const zEmailSendRoutingData = z.object({
	body: zEmailSendRequest,
	path: z.never().optional(),
	query: z.object({
		worker: z.string(),
	}),
});

/**
 * Send test email response.
 */
export const zEmailSendRoutingResponse = zWorkersApiResponseCommon.and(
	z.object({
		result: z
			.object({
				messageId: z.string().optional(),
				outcome: z.enum(["ok", "exception"]).optional(),
				rejectReason: z.string().optional(),
			})
			.optional(),
	})
);

export const zEmailListSendingData = z.object({
	body: z.never().optional(),
	path: z.never().optional(),
	query: z
		.object({
			worker: z.string().optional(),
			email_id: z.string().optional(),
			cursor: z.string().optional(),
			per_page: z.int().gte(1).lte(100).optional().default(25),
		})
		.optional(),
});

/**
 * List sent emails response.
 */
export const zEmailListSendingResponse = zWorkersApiResponseCommon.and(
	z.object({
		result: z
			.union([z.array(zEmailSendingItem), zEmailSendingDetail])
			.optional(),
		result_info: z
			.object({
				count: z.number().optional(),
				cursor: z.string().optional(),
				per_page: z.int().optional(),
				has_more: z.boolean().optional(),
			})
			.optional(),
	})
);

export const zWorkflowsListWorkflowsData = z.object({
	body: z.never().optional(),
	path: z.never().optional(),
	query: z.never().optional(),
});

/**
 * List Workflows response.
 */
export const zWorkflowsListWorkflowsResponse = zWorkersApiResponseCommon.and(
	z.object({
		result: z.array(zWorkflowsWorkflow).optional(),
		result_info: z
			.object({
				count: z.number().optional(),
			})
			.optional(),
	})
);

export const zWorkflowsDeleteWorkflowData = z.object({
	body: z.never().optional(),
	path: z.object({
		workflow_name: zWorkflowsWorkflowName,
	}),
	query: z.never().optional(),
});

/**
 * Delete Workflow response.
 */
export const zWorkflowsDeleteWorkflowResponse = zWorkersApiResponseCommon.and(
	z.object({
		result: z
			.object({
				status: z.string().optional(),
				success: z.boolean().optional(),
			})
			.optional(),
	})
);

export const zWorkflowsGetWorkflowDetailsData = z.object({
	body: z.never().optional(),
	path: z.object({
		workflow_name: zWorkflowsWorkflowName,
	}),
	query: z.never().optional(),
});

/**
 * Get Workflow Details response.
 */
export const zWorkflowsGetWorkflowDetailsResponse =
	zWorkersApiResponseCommon.and(
		z.object({
			result: zWorkflowsWorkflowDetails.optional(),
		})
	);

export const zWorkflowsListInstancesData = z.object({
	body: z.never().optional(),
	path: z.object({
		workflow_name: zWorkflowsWorkflowName,
	}),
	query: z
		.object({
			page: z.number().gte(1).optional().default(1),
			per_page: z.number().gte(1).lte(100).optional().default(25),
			status: z
				.enum([
					"queued",
					"running",
					"paused",
					"errored",
					"terminated",
					"complete",
					"waitingForPause",
					"waiting",
				])
				.optional(),
			date_start: z.iso.datetime().optional(),
			date_end: z.iso.datetime().optional(),
		})
		.optional(),
});

/**
 * List Workflow Instances response.
 */
export const zWorkflowsListInstancesResponse = zWorkersApiResponseCommon.and(
	z.object({
		result: z.array(zWorkflowsInstance).optional(),
		result_info: z
			.object({
				page: z.number().optional(),
				per_page: z.number().optional(),
				total_count: z.number().optional(),
				total_pages: z.number().optional(),
			})
			.optional(),
	})
);

export const zWorkflowsCreateInstanceData = z.object({
	body: z
		.object({
			id: z.string().optional(),
			params: z.unknown().optional(),
		})
		.optional(),
	path: z.object({
		workflow_name: zWorkflowsWorkflowName,
	}),
	query: z.never().optional(),
});

/**
 * Create Workflow Instance response.
 */
export const zWorkflowsCreateInstanceResponse = zWorkersApiResponseCommon.and(
	z.object({
		result: z
			.object({
				id: z.string(),
			})
			.optional(),
	})
);

export const zWorkflowsBatchDeleteInstancesData = z.object({
	body: z.object({
		instances: z
			.array(
				z
					.string()
					.min(1)
					.max(271)
					.regex(/^[a-zA-Z0-9, *\/#_-]+$/)
			)
			.min(1)
			.max(100),
	}),
	path: z.object({
		workflow_name: zWorkflowsWorkflowName,
	}),
	query: z.never().optional(),
});

/**
 * Batch delete Workflow Instances response.
 */
export const zWorkflowsBatchDeleteInstancesResponse =
	zWorkersApiResponseCommon.and(
		z.object({
			result: z
				.object({
					deleted: z.array(
						z.object({
							id: z.string(),
						})
					),
					errors: z.array(
						z.object({
							id: z.string(),
							code: z.number(),
							message: z.string(),
						})
					),
				})
				.optional(),
		})
	);

export const zWorkflowsDeleteInstanceData = z.object({
	body: z.never().optional(),
	path: z.object({
		workflow_name: zWorkflowsWorkflowName,
		instance_id: zWorkflowsInstanceId,
	}),
	query: z.never().optional(),
});

/**
 * Delete Workflow Instance response.
 */
export const zWorkflowsDeleteInstanceResponse = zWorkersApiResponseCommon.and(
	z.object({
		result: z
			.object({
				success: z.boolean().optional(),
			})
			.optional(),
	})
);

export const zWorkflowsGetInstanceDetailsData = z.object({
	body: z.never().optional(),
	path: z.object({
		workflow_name: zWorkflowsWorkflowName,
		instance_id: zWorkflowsInstanceId,
	}),
	query: z.never().optional(),
});

/**
 * Get Workflow Instance Details response.
 */
export const zWorkflowsGetInstanceDetailsResponse =
	zWorkersApiResponseCommon.and(
		z.object({
			result: zWorkflowsInstanceDetails.optional(),
		})
	);

export const zWorkflowsChangeInstanceStatusData = z.object({
	body: z.object({
		action: z.enum(["pause", "resume", "restart", "terminate"]),
		from: z
			.object({
				name: z.string(),
				count: z.int().gte(1).optional(),
				type: z.enum(["do", "sleep", "waitForEvent"]).optional(),
			})
			.optional(),
		rollback: z.boolean().optional(),
	}),
	path: z.object({
		workflow_name: zWorkflowsWorkflowName,
		instance_id: zWorkflowsInstanceId,
	}),
	query: z.never().optional(),
});

/**
 * Change Workflow Instance Status response.
 */
export const zWorkflowsChangeInstanceStatusResponse =
	zWorkersApiResponseCommon.and(
		z.object({
			result: z
				.object({
					success: z.boolean().optional(),
				})
				.optional(),
		})
	);

export const zWorkflowsSendInstanceEventData = z.object({
	body: z.unknown().optional(),
	path: z.object({
		workflow_name: zWorkflowsWorkflowName,
		instance_id: zWorkflowsInstanceId,
		event_type: z.string(),
	}),
	query: z.never().optional(),
});

/**
 * Send Event response.
 */
export const zWorkflowsSendInstanceEventResponse = zWorkersApiResponseCommon;

export const zObservabilityQueryData = z.object({
	body: z.object({
		sql: z.string(),
		params: z.array(z.unknown()).optional(),
	}),
	path: z.never().optional(),
	query: z.never().optional(),
});

/**
 * Query response.
 */
export const zObservabilityQueryResponse = zWorkersApiResponseCommon.and(
	z.object({
		result: zObservabilityQueryResult.optional(),
	})
);

export const zObservabilityClearData = z.object({
	body: z.never().optional(),
	path: z.never().optional(),
	query: z.never().optional(),
});

/**
 * Clear response.
 */
export const zObservabilityClearResponse = zWorkersApiResponseCommon;
